import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';

export interface IMenuItemSelectorComponentConfiguration extends InputSelectComponent.Configuration {
	targetMenu: CM.Path.TPathRaw
};

export class MenuItemSelectorComponent extends InputSelectComponent.Component<
	MenuItemSelectorComponent,
	IMenuItemSelectorComponentConfiguration
> {
	static override getInputEventSubType() {
		return InputSelectComponent.Component.type;
	};

	targetMenu!: MenuViewsComponent<any, any>;

	override async component_initialize() {
		await super.component_initialize();

		const targetMenu = this.component_find(this.component_configuration.targetMenu);

		if (!(targetMenu instanceof MenuViewsComponent)) {
			this.component_throwUserError('targetMenu must be a MenuViewsComponent', { targetMenu });
		}

		this.targetMenu = targetMenu;
	};

	protected override async onInputButton(ev : STD.events.Event<any, CM.Component<any, any>>) {
		const allAreClosable = await Promise.all(
				this.targetMenu.currentSections
					.map(section => this.targetMenu.isClosable(section.id))
			).then(list => list.every(isClosable => isClosable));

		if (!allAreClosable || !await this.targetMenu.isOpenable(ev.target.id))
			return;

		await super.onInputButton(ev);
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IMenuItemSelectorComponentConfiguration
	) {
		super(descriptor, configuration);

		if (!configuration.targetMenu) {
			this.component_throwUserError('missing targetMenu', {});
		}
	};
};
export namespace NS {
	export const Component = MenuItemSelectorComponent;
	export type Component = MenuItemSelectorComponent;
	export type Configuration = IMenuItemSelectorComponentConfiguration;
}
;
import './MenuItemSelector.scss';
import {MenuViewsComponent} from '../MenuViews/MenuViews';
import { NS as InputSelectComponent } from '../../inputs/InputSelect/InputSelect';
import manifestXMLSource from './MenuItemSelector.xml';

CM.Manager.declare({
	id: 'menu-item-selector',
	type: MenuItemSelectorComponent,
	manifest: manifestXMLSource
});
